module.exports = __webpack_public_path__ + "images/logos/safeguard-self-storage.png";